import type { SVGProps } from "react";

export const QuestionBubbleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Speech bubble */}
      <path
        d="M28 10C19.72 10 13 16.72 13 25C13 29.5 15 33.5 18 36L12 46L22 42C24.5 42.5 26.2 42.7 28 42.7C36.28 42.7 43 36 43 27.7C43 19.42 36.28 12.7 28 12.7V10Z"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Question mark */}
      <path
        d="M28 32C28.5523 32 29 31.5523 29 31C29 30.4477 28.5523 30 28 30C27.4477 30 27 30.4477 27 31C27 31.5523 27.4477 32 28 32Z"
        fill="currentColor"
      />
      <path
        d="M28 26C28.5523 26 29 25.5523 29 25V20C29 19.4477 28.5523 19 28 19C27.4477 19 27 19.4477 27 20V25C27 25.5523 27.4477 26 28 26Z"
        fill="currentColor"
      />
    </svg>
  );
};
